import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class StrictEmailValidatorUtils {
  static strictEmailValidator(control: AbstractControl): ValidationErrors | null {
    const email: string = control.value;
    if (!email) return null;

    const emailPattern: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailPattern.test(email)) {
      return { email: true };
    }
    return null;
  }
}
